import __request__ from 'routing/request';
interface EmailNotificationDefaults {
    readonly html_body: string;
    readonly text_body: string;
    readonly override_defaults: boolean;
}
/**
 * Get existing email notification defaults
 */
export function getEmailNotificationDefaults(): Promise<EmailNotificationDefaults> {
    return __request__('GET', '/plugins/org.graylog.plugins.customization/email_notification_defaults', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Update email notification defaults
 */
export function updateEmailNotificationDefaults(JSONBody?: EmailNotificationDefaults): Promise<EmailNotificationDefaults> {
    return __request__('POST', '/plugins/org.graylog.plugins.customization/email_notification_defaults', JSONBody, {}, {
        'Accept': ['application/json']
    });
}
